import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ResearchWidgets from '../../../widgets/intellectualProperty/ResearchWidgets'
import InnovationWidgets from '../../../widgets/intellectualProperty/InnovationWidgets'
import { Col, Panel, Row } from 'rsuite'
import { callIntellectualProperty } from '../../../redux/actions/intellectualProperty'

export default function IntellectualProperty() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // setSchema(mockSchema.model)
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await callIntellectualProperty(projectId)
      console.log('handleGetSchema => ', _schema?.form)
      setSchema(_schema)
    } catch (error) {
      console.log('error => ', error)
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema?.header} subHeader={schema.subHeader} hideSubTitle={false} />

      <Panel
        shaded
        header={schema.form?.projectInfo?.header || ''}
        bordered
        collapsible
        defaultExpanded
      >
        <div style={{ marginTop: -25 }}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              {`รหัสโครงการ : ${schema?.form?.projectInfo?.projectCode || ''} (เลขที่ข้อตกลง : ${
                schema?.form?.projectInfo?.contractNo || ''
              }) : ${schema?.form?.projectInfo?.projectName || ''}`}
            </Col>
          </Row>
        </div>
      </Panel>

      <br />

      {schema.form?.research && (
        <>
          <ResearchWidgets schema={schema.form?.research} />
          <br />
        </>
      )}

      {schema?.form?.innovation && (
        <>
          <InnovationWidgets schema={schema?.form?.innovation} />
          <br />
        </>
      )}

      {/* <PropertyArisingFromProjectWidget schema={schema.form?.propertyArisingFromProject} /> */}
    </SidebarProposal>
  )

  const mockSchema = {
    model: {
      header: ' ข้อมูลงานวิจัยและนวัตกรรม',
      subHeader: '',
      disabled: false,
      form: {
        projectInfo: {
          projectId: null,
          versionCode: '11.0',
          projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
          projectNameTitle: 'ชื่อโครงการ',
          projectName: 'รณรงลดโรค ลดโควิด 09',
          projectCodeTitle: 'รหัสโครงการ',
          projectCode: '65-10063',
          projectRequestCodeTitle: 'รหัสข้อเสนอโครงการ',
          projectRequestCode: 'R65-10192',
          projectTypeTitle: 'ประเภทโครงการ',
          projectType: 'โครงการพัฒนาและปฏิบัติการ',
          projectProposalTypeTitle: 'ประเภทโครงการ',
          projectProposalType: 'โครงการ',
          statusTitle: 'สถานะ',
          status: 'ดำเนินการ',
          projectProposalStyleTitle: 'ลักษณะโครงการ',
          projectProposalStyle: 'โครงการใหม่',
          ownerNameTitle: 'ผู้รับทุน',
          ownerName: 'นายอิศยา กาบนันทา',
          activityTypeTitle: 'ลักษณะกิจกรรม',
          activityTypeTitle2: '(ประเภทโครงการ)',
          activityType: 'โครงการพัฒนาและปฏิบัติการ',
          statusCode: 6,
          staffNameTitle: 'ชื่อผู้ประสาน',
          staffName: 'นายคมสันต์ วงศ์ชัย (สำนัก 6)',
          responsinatorNameTitle: 'ผู้รับผิดชอบโครงการ',
          responsinatorName: 'นายอิศยา กาบนันทา',
          projectPeriodTitle: 'ระยะเวลาโครงการ',
          projectPeriod: '12/พ.ค./2565 - 12/พ.ย./2565',
          projectContractNoTitle: 'เลขที่ข้อตกลง',
          projectContractNo: '65-P1-0070',
        },
        innovation: {
          header: 'ข้อมูลนวัตกรรม',
          input: {
            name: {
              name: 'name',
              label: 'ชื่อผลงานนวัตกรรม',
              value: null,
              disabled: false,
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ชื่อผลงานนวัตกรรม' },
              ],
            },
            detail: {
              name: 'detail',
              label: 'รายละเอียด',
              value: null,
              disabled: false,
            },
            innovationType: {
              label: 'ประเภทผลงานนวัตกรรม',
              name: 'innovationType',
              value: null,
              options: [
                {
                  disabled: false,
                  label: 'ทดสอบ',
                  value: '1',
                },
                {
                  disabled: false,
                  label: 'อื่นๆ',
                  value: '999',
                },
              ],
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'เลือกประเภทผลงานนวัตกรรม' },
              ],
              otherInnovationType: {
                name: 'otherInnovationType',
                label: 'อื่นๆ',
                value: null,
                disabled: false,
                validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก อื่นๆ' }],
              },
            },
            issue: {
              label: 'ประเด็น',
              name: 'issue',
              value: null,
              options: [
                {
                  disabled: false,
                  label: 'ทดสอบ',
                  value: '1',
                },
                {
                  disabled: false,
                  label: 'อื่นๆ',
                  value: '999',
                },
              ],
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกประเด็น' }],
              otherIssue: {
                name: 'otherIssue',
                label: 'อื่นๆ',
                value: null,
                disabled: false,
                validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก อื่นๆ' }],
              },
            },
            target: {
              label: 'กลุ่มเป้าหมาย',
              name: 'target',
              value: null,
              options: [
                {
                  disabled: false,
                  label: 'ทดสอบ',
                  value: '1',
                },
                {
                  disabled: false,
                  label: 'อื่นๆ',
                  value: '999',
                },
              ],
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกกลุ่มเป้าหมาย' }],
              otherTarget: {
                name: 'otherTarget',
                label: 'อื่นๆ',
                value: null,
                disabled: false,
                validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก อื่นๆ' }],
              },
            },
            creator: {
              name: 'creator',
              label: 'ผู้สร้างสรรค์',
              value: null,
              disabled: false,
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ผู้สร้างสรรค์' },
              ],
            },
            yearOfDevelopment: {
              label: 'ปีที่พัฒนา',
              name: 'yearOfDevelopment',
              value: null,
              options: [
                {
                  disabled: false,
                  label: '2558',
                  value: '2558',
                },
                {
                  disabled: false,
                  label: '2559',
                  value: '2559',
                },
              ],
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกปีที่พัฒนา' }],
            },
            attachFiles: {
              name: 'attachFiles',
              header: 'แนบรูปภาพประกอบ',
              buttonText: 'รูปภาพประกอบ (1-10)',
              fileSize: 50,
              fileType: '.jpg, .jpeg, .png',
              description: ['แนบรูปภาพประกอบ (1-10) รูป'],
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาแนบรูปภาพประกอบ' }],
              value: [],
              id: null,
            },
            utilization: {
              label: 'การนำไปใช้ประโยชน์',
              name: 'utilization',
              value: null,
              options: [
                {
                  disabled: false,
                  label: 'ทดสอบ',
                  value: '1',
                },
                {
                  disabled: false,
                  label: 'อื่นๆ',
                  value: '999',
                },
              ],
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'เลือกการนำไปใช้ประโยชน์' },
              ],
            },
            trlLevel: {
              label: 'ระดับความพร้อมทางเทคโนโลยี (TRL)',
              name: 'trlLevel',
              value: null,
              options: [
                {
                  disabled: false,
                  label: 'ทดสอบ',
                  value: '1',
                },
                {
                  disabled: false,
                  label: 'อื่นๆ',
                  value: '999',
                },
              ],
              // validators: [
              //   {
              //     type: 'REQUIRED',
              //     value: null,
              //     errorMessage: 'เลือกระดับความพร้อมทางเทคโนโลยี (TRL)',
              //   },
              // ],
            },
            slrLevel: {
              label: 'ระดับความพร้อมทางสังคม',
              name: 'slrLevel',
              value: null,
              options: [
                {
                  disabled: false,
                  label: 'ทดสอบ',
                  value: '1',
                },
                {
                  disabled: false,
                  label: 'อื่นๆ',
                  value: '999',
                },
              ],
              // validators: [
              //   {
              //     type: 'REQUIRED',
              //     value: null,
              //     errorMessage: 'เลือกระดับความพร้อมทางสังคม',
              //   },
              // ],
            },
            detailMore: {
              name: 'detailMore',
              label: 'รายละเอียดเพิ่มเติม',
              value: null,
              disabled: false,
            },
          },
          contactChannels: {
            title: 'ช่องทางการติดต่อ',
            fullName: {
              name: 'fullName',
              label: 'ชื่อ - นามสกุล',
              value: null,
              disabled: false,
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ชื่อ - นามสกุล' },
              ],
            },
            email: {
              name: 'email',
              label: 'อีเมล',
              value: null,
              disabled: false,
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก อีเมล' }],
            },
            telephone: {
              name: 'telephone',
              label: 'เบอร์โทรศัพท์',
              value: null,
              disabled: false,
              // validators: [
              //   { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก เบอร์โทรศัพท์' },
              // ],
            },
            agency: {
              name: 'agency',
              label: 'ชื่อหน่วยงาน',
              value: null,
              disabled: false,
              // validators: [
              //   { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ชื่อหน่วยงาน' },
              // ],
            },
          },
          buttonText: {
            //            saveDraftButtonName: 'บันทึกร่าง',
            saveButtonName: 'บันทึก',
            //            sendButtonName: 'ส่งไปจัดเก็บ',
          },
          // values: null,
          values: [
            {
              name: '',
              detail: '',
              innovationType: '',
              otherInnovationType: '',
              issue: [],
              otherIssue: '',
              target: [],
              otherTarget: '',
              creator: [''],
              yearOfDevelopment: '',
              attachFiles: [],
              utilization: '',
              trlLevel: '',
              slrLevel: '',
              detailMore: '',
              fullName: '',
              email: '',
              telephone: '',
              agency: '',
            },
            {
              name: '',
              detail: '',
              innovationType: '',
              otherInnovationType: '',
              issue: [],
              otherIssue: '',
              target: [],
              otherTarget: '',
              creator: [''],
              yearOfDevelopment: '',
              attachFiles: [],
              utilization: '',
              trlLevel: '',
              slrLevel: '',
              detailMore: '',
              fullName: '',
              email: '',
              telephone: '',
              agency: '',
            },
          ],
        },
        research: {
          header: 'ข้อมูลงานวิจัย',
          input: {
            nameTh: {
              name: 'nameTh',
              label: 'ชื่อผลงานวิจัย (ภาษาไทย)',
              value: null,
              disabled: false,
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอก ชื่อผลงานวิจัย (ภาษาไทย)',
                },
              ],
            },
            nameEng: {
              name: 'nameEng',
              label: 'ชื่อผลงานวิจัย (ภาษาอังกฤษ)',
              value: null,
              disabled: false,
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณากรอก ชื่อผลงานวิจัย (ภาษาอังกฤษ)',
                },
              ],
            },
            issue: {
              label: 'ประเด็น',
              name: 'issue',
              value: null,
              options: [],
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกประเด็น' }],
              otherIssue: {
                name: 'otherIssue',
                label: 'อื่นๆ',
                value: null,
                disabled: false,
                validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก อื่นๆ' }],
              },
            },
            target: {
              label: 'กลุ่มเป้าหมาย',
              name: 'target',
              value: null,
              options: [],
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกกลุ่มเป้าหมาย' }],
              otherTarget: {
                name: 'otherTarget',
                label: 'อื่นๆ',
                value: null,
                disabled: false,
                validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก อื่นๆ' }],
              },
            },
            //            importance: {
            //              name: 'importance',
            //              label: 'ความสำคัญของงานวิจัย',
            //              value: null,
            //              disabled: false,
            //              validators: [
            //                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ความสำคัญของงานวิจัย' },
            //              ],
            //            },
            objective: {
              name: 'objective',
              label: 'วัตถุประสงค์',
              value: null,
              disabled: false,
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก วัตถุประสงค์' },
              ],
            },
            benefit: {
              name: 'benefit',
              label: 'ประโยชน์ของผลงานวิจัย',
              value: null,
              disabled: false,
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ประโยชน์ของผลงานวิจัย' },
              ],
            },
            nameOfResearcher: {
              name: 'nameOfResearcher',
              label: 'ชื่อนักวิจัย',
              value: null,
              disabled: false,
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ชื่อนักวิจัย' },
              ],
            },
            yearOfDevelopment: {
              label: 'ปีที่เผยแพร่',
              name: 'yearOfDevelopment',
              value: null,
              options: [
                {
                  disabled: false,
                  label: '2558',
                  value: '2558',
                },
                {
                  disabled: false,
                  label: '2559',
                  value: '2559',
                },
              ],
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกปีที่พัฒนา' }],
            },
            attachFiles: {
              name: 'attachFiles',
              header: 'แนบรูปภาพประกอบ (1-10)',
              buttonText: 'รูปภาพประกอบ (1-10)',
              fileSize: 50,
              fileType: '.jpg, .jpeg, .png',
              description: ['แนบรูปภาพประกอบ (1-10) รูป'],
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณาแนบรูปภาพประกอบ' }],
              value: [],
              id: null,
            },
            completeEditionAttachFiles: {
              name: 'completeEditionAttachFiles',
              header: 'Upload file ผลงานฉบับสบูรณ์',
              buttonText: 'Upload file ผลงานฉบับสบูรณ์',
              fileSize: 50,
              fileType: '.pdf',
              description: ['Upload file ผลงานฉบับสบูรณ์'],
              validators: [
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณา Upload file ผลงานฉบับสบูรณ์',
                },
              ],
              value: [],
              id: null,
            },
            // linked: {
            //   name: 'linked',
            //   label: 'ลิงก์ผลงานฉบับสมบรูณ์',
            //   value: null,
            //   disabled: false,
            //   validators: [
            //     { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ลิงก์ผลงานฉบับสมบรูณ์' },
            //   ],
            // },
          },
          contactChannels: {
            fullName: {
              name: 'fullName',
              label: 'ชื่อ - นามสกุล',
              value: null,
              disabled: false,
              validators: [
                { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ชื่อ - นามสกุล' },
              ],
            },
            email: {
              name: 'email',
              label: 'อีเมล',
              value: null,
              disabled: false,
              validators: [{ type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก อีเมล' }],
            },
            telephone: {
              name: 'telephone',
              label: 'เบอร์โทรศัพท์',
              value: null,
              disabled: false,
              // validators: [
              //   { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก เบอร์โทรศัพท์' },
              // ],
            },
            agency: {
              name: 'agency',
              label: 'ชื่อหน่วยงาน',
              value: null,
              disabled: false,
              // validators: [
              //   { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอก ชื่อหน่วยงาน' },
              // ],
            },
          },
          buttonText: {
            disabled: true,
            //            saveDraftButtonName: 'บันทึกร่าง',
            saveButtonName: 'บันทึก',
            //            sendButtonName: 'ส่งไปจัดเก็บ',
          },
          values: [
            {
              nameTh: '',
              nameEng: '',
              issue: [],
              target: [],
              importance: '',
              objective: '',
              benefit: '',
              nameOfResearcher: [''],
              yearOfDevelopment: '',
              attachFiles: [],
              linked: '',
              fullName: '',
              email: '',
              telephone: '',
              agency: '',
            },
            {
              nameTh: '',
              nameEng: '',
              issue: [],
              target: [],
              importance: '',
              objective: '',
              benefit: '',
              nameOfResearcher: [''],
              yearOfDevelopment: '',
              attachFiles: [],
              linked: '',
              fullName: '',
              email: '',
              telephone: '',
              agency: '',
            },
          ],
        },
        // propertyArisingFromProject: {
        //   header: 'ข้อมูลทรัพย์สินทางปัญญา',
        //   propertyArisingFromProjectInput: {
        //     title: 'ข้อมูลทรัพย์สินทางปัญญา',
        //     label: 'มีทรัพย์สินทางปัญญาที่เกิดจากโครงการนี้',
        //     name: 'propertyArisingFromProject',
        //     value: '1',
        //     options: [
        //       {
        //         disabled: false,
        //         label: 'ไม่มี',
        //         value: '1',
        //       },
        //       {
        //         disabled: false,
        //         label: 'มีทรัพย์สินทางปัญญา และนำไปจดแจ้งแล้ว',
        //         value: '2',
        //       },
        //       {
        //         disabled: false,
        //         label: 'มี และมีแผนที่จะนำทรัพย์สิททางปัญญาไปจดแจ้ง',
        //         value: '3',
        //       },
        //     ],
        //   },
        //   buttonText: {
        //     disabled: true,
        //     //            sendButtonName: 'ส่งไปจัดเก็บ',
        //     saveButtonName: 'บันทึก',
        //   },
        // },
      },
    },
  }
}
